namespace $ {
	export class $mol_switch extends $mol_check_list {
		
		/**
		 * ```tree
		 * value?val \
		 * ```
		 */
		@ $mol_mem
		value(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
	}
	
}

